import React from 'react'
import cx from 'classnames'
import { EMPTY_PLACEHOLDER } from './types'

const TableCell = ({
  value,
  className,
  rowSpan
}: {
  value?: string | number | null
  className?: string
  rowSpan?: number
}) => {
  const isEmpty = value === null || value === undefined || value === ''

  return (
    <td rowSpan={rowSpan} className={cx(className, { 'table-cell--empty': isEmpty })}>
      {isEmpty ? EMPTY_PLACEHOLDER : value}
    </td>
  )
}

export default TableCell
